import { Injectable } from "@angular/core";
import { ManualListItem } from "../models/manual/manual-list-item";
import { Adapter } from "@core/adapter";

@Injectable({providedIn: 'root'})
export class ManualListAdapter implements Adapter<ManualListItem> {
  constructor(){}
  adapt(item: any): ManualListItem {
    return {
      id: item['@id'],
      slug:item.slug,
      name: item.title,
      language: item.language.split('/').pop(),
      status: item.visible,
      updatedAt : item.updatedAt
    };
  }
}
